import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { Icons } from '../../../../shared/helpers/icons';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EopSectionService } from '../../../../shared/services/eopSection.service';
import { IEopSection } from '../../../../shared/models/eopSection';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { UserDataService } from '../../../../shared/services/userData.service';
import { NoEmojiDirective } from '../../../../shared/helpers/noEmoji.directive';
declare var initFlowbite: any;

@Component({
  selector: 'edit-plan',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    ReactiveFormsModule,
    SpinnerComponent,
    NoEmojiDirective
  ],
  templateUrl: './edit-plan.component.html',
  styleUrl: './edit-plan.component.css'
})
export class EditPlanComponent implements OnInit {
  @Input() currentPlan: IEopSection[] = [];
  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<any>();

  icons = Icons;
  currentBuildingId: string | null = null;
  defaultEopSections: IEopSection[] = [
    {
      section_id: 11,
      type: 'Introductory Material'
    },
    {
      section_id: 12,
      type: 'Purpose and Situation Overview'
    },
    {
      section_id: 13,
      type: 'Concept of Operations'
    },
    {
      section_id: 14,
      type: 'Organization and Assignment of Responsibilities'
    },
    {
      section_id: 15,
      type: 'Direction, Control, and Coordination'
    },
    {
      section_id: 16,
      type: 'Information Collection, Analysis, and Dissemination'
    },
    {
      section_id: 17,
      type: 'Training and Exercises'
    },
    {
      section_id: 18,
      type: 'Administration, Finance, and Logistics'
    },
    {
      section_id: 19,
      type: 'Plan Development and Maintenance'
    },
    {
      section_id: 20,
      type: 'Authorities and References'
    }
  ];

  loading: boolean = false;
  editPlanForm = new FormGroup({
    selected_sections: new FormControl<number[]>([]) 
  })
  
  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private userDataService: UserDataService,
    private eopSectionService: EopSectionService
  ) { }

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => initFlowbite(), 100);
    }
    console.table(this.currentPlan);

    const extracted = this.currentPlan.map(item => ({
      building_id: item.building_id,
      section_id: item.section_id
    }));
    console.table(extracted);
    const selectedSectionIds = this.currentPlan.map(p => p.section_id);
    this.editPlanForm.get('selected_sections')?.setValue(selectedSectionIds);
  }

  onCheckboxChange(e: Event, sectionId: number) {
    const control = this.editPlanForm.get('selected_sections');
    const currentValues: number[] = control?.value || [];
  
    if ((e.target as HTMLInputElement).checked) {
      if (!currentValues.includes(sectionId)) {
        currentValues.push(sectionId);
      }
    } else {
      const index = currentValues.indexOf(sectionId);
      if (index >= 0) {
        currentValues.splice(index, 1);
      }
    }
  
    control?.setValue([...currentValues]);
  }

  savePlan() {
    if (this.currentBuildingId) {
      this.loading = true;
      const selectedSectionIds: number[] = this.editPlanForm.get('selected_sections')?.value || [];
      console.log(selectedSectionIds);
      this.eopSectionService.updateBasicPlan(this.currentBuildingId, selectedSectionIds).subscribe({
        next: (response) => {
          this.loading = false;
          console.log(response);
          this.onSave.emit({'type': 'success', 'message': 'This occurred after updating the Basic Plan.'});
        },
        error: (error) => {
          this.loading = false;
          console.error('Error:', error.message);
          this.onSave.emit({type: 'unsuccess', 'message': error.message});
        }
      });
    }
  }

  handleCloseEditPlan(): void {
    this.onClose.emit();
  }
}
